import {get, post, put, _delete} from './Tools';

const importBulk = async (file, tipo, force_save = false, anio = null) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('tipo', tipo);
  formData.append('force_save', force_save ? 1 : 0);
  if (anio !== null && anio !== undefined && anio !== '') {
    formData.append('anio', anio);
  }
  
  const token = localStorage.getItem('token');
  
  try {
    const result = await fetch(`${process.env.REACT_APP_SERVER}nomina_acumulado/import`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'x-access-token': '1',
      },
      body: formData,
    });
    
    const data = await result.json();
    return data;
  } catch (error) {
    return { ok: false, message: error.message };
  }
};

const importBulkConfirm = async (tipo, cached_records, anio = null) => {
  const token = localStorage.getItem('token');
  
  try {
    const result = await fetch(`${process.env.REACT_APP_SERVER}nomina_acumulado/import/confirm`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'x-access-token': '1',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        tipo,
        cached_records,
        anio
      }),
    });
    
    const data = await result.json();
    return data;
  } catch (error) {
    return { ok: false, message: error.message };
  }
};

export { importBulk, importBulkConfirm };
